<template>
    <div class="column-chart">
        <div v-for="item in 5"
             ref="chartItem"
             :key="item"
             class="column-chart__item"
             :class="{ active: activeIndex === item }"
        />
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        activeIndex: number
    }>()
    const chartItem = ref()
</script>

<style lang="scss" scoped>
    .column-chart{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        flex-flow: row nowrap;
        width: 100%;
        max-width: 120px;
        min-height: 90px;
        padding-top: 18px;

        &__item{
            flex: 1 1 auto;
            width: 20%;
            border-radius: 21px 21px 0 0;
            background-color: var(--blue-100);

            &.active{
                background-color: var(--blue-500);
            }

            &:nth-child(1){height: 20%;}

            &:nth-child(2){height: 40%;}

            &:nth-child(3){height: 60%;}

            &:nth-child(4){height: 80%;}

            &:nth-child(5){height: 100%;}

            &:not(:first-child){
                margin-left: 4px;
            }
        }
    }
</style>
